import { ContentCluster } from '@app/components/base/content-structure/ContentCluster';
import {
  UsersAuthzPermissionDefinitionDto,
  UsersAuthzPermissionsByProviderDto,
} from '@mi-front/api-v2';
import { Grid } from '@mui/material';
import { useLanguage } from '../../../../core/hooks/useLanguage';
import { PermissionItemComponentProps } from './ActionPermissionsView';

interface Props<T> {
  readonly provider: UsersAuthzPermissionsByProviderDto['provider'];
  readonly permissions: UsersAuthzPermissionDefinitionDto[];
  readonly permissionsState: T[];
  readonly PermissionItemComponent: React.ComponentType<PermissionItemComponentProps<T>>;
  /** Hairline above this section. Off for the first provider group. */
  readonly divider?: boolean;
}

/**
 * Permission controls for one authz provider, grouped under a content-cluster title.
 */
export function ActionPermissionsSection<T>(p: Props<T>) {
  const lang = useLanguage();
  const { provider, permissions, permissionsState, PermissionItemComponent, divider = true } = p;

  // Get the provider description in the current locale
  const getProviderDescription = () => {
    const description = provider.description as Record<string, string>;

    // Default to English if current locale not available
    return description[lang] || description.en || provider.id;
  };

  if (permissions.length === 0) {
    return null;
  }

  return (
    <ContentCluster title={getProviderDescription()} divider={divider}>
      <Grid container spacing={2}>
        {permissions.map((permission, index) => (
          <Grid key={permission.id} item xs={12} md={6} lg={4}>
            <PermissionItemComponent
              permissionState={permissionsState[index]}
              permissionDefinition={permission}
            />
          </Grid>
        ))}
      </Grid>
    </ContentCluster>
  );
}
